import { Box, Button, Chip, Paper, Typography } from '@mui/material';
import { useFormContext } from 'react-hook-form';

import { Invoice } from 'openapi';

import { useTranslations } from 'context/TranslationContext';

import { InvoiceVerificationFieldName } from 'utils/constants/invoiceVerificationFieldNames';

import { cardContentStyle, cardHeaderStyle } from 'styles/shared/CardStyle';

interface CounterpartyDisplayCardProps {
  currentInvoice: Invoice;
  isEditing: boolean;
  onToggleEdit: () => void;
}

export const CounterpartyDisplayCard = ({
  isEditing,
  onToggleEdit
}: CounterpartyDisplayCardProps) => {
  const { translate } = useTranslations();
  const { watch } = useFormContext();

  const watchedCounterpartyName = watch(
    InvoiceVerificationFieldName.CounterpartyName
  );
  const watchedCounterpartyRegistrationNumber = watch(
    InvoiceVerificationFieldName.CounterpartyRegistrationNumber
  );
  const watchedCounterpartyVatNumber = watch(
    InvoiceVerificationFieldName.CounterpartyVatNumber
  );
  const isCounterpartyValidated = watch(
    InvoiceVerificationFieldName.IsCounterpartyValidated
  );

  const isCounterpartySelected = Boolean(watchedCounterpartyName);

  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: '1rem',
        border: '1px solid #e5e7eb'
      }}
    >
      <Box sx={{ ...cardHeaderStyle, justifyContent: 'space-between' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography
            variant="body1"
            sx={{
              fontSize: '0.75rem',
              fontWeight: 600
            }}
          >
            {isCounterpartySelected ? watchedCounterpartyName : '-'}
          </Typography>
          {isCounterpartySelected &&
            (isCounterpartyValidated ? (
              <Chip
                size="small"
                color="success"
                label={translate('labels.validatedCounterparty')}
              />
            ) : (
              <Chip
                size="small"
                color="warning"
                label={translate('labels.notValidatedCounterparty')}
              />
            ))}
        </Box>
        <Button variant="outlined" size="small" onClick={onToggleEdit}>
          {isEditing
            ? translate('buttons.cancel')
            : translate('buttons.change')}
        </Button>
      </Box>

      <Box sx={cardContentStyle}>
        <Box sx={{ display: 'flex', gap: 2, textAlign: 'left' }}>
          <Box
            sx={{
              display: 'flex',
              flex: 1,
              gap: 0.5
            }}
          >
            <Typography fontSize="0.875rem">
              {`${translate('labels.companyRegistrationNumber')}:`}
            </Typography>
            <Typography fontSize="0.875rem">
              {watchedCounterpartyRegistrationNumber || '-'}
            </Typography>
          </Box>
          <Box
            sx={{
              display: 'flex',
              flex: 1,
              gap: 0.5
            }}
          >
            <Typography fontSize="0.875rem">
              {`${translate('labels.vatNumber')}:`}
            </Typography>
            <Typography fontSize="0.875rem">
              {watchedCounterpartyVatNumber || '-'}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Paper>
  );
};
